import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import icon_volunteer from '@/components/icon_volunteer.vue';
import icon_internship from '@/components/icon_internship.vue';
import icon_spanish from '@/components/icon_spanish.vue';
import icon_accommodation from '@/components/icon_accommodation.vue';
import icon_tours from '@/components/icon_tours.vue';
import icon_packages from '@/components/icon_packages.vue';
import icon_sale from '@/components/icon_sale.vue';
import icon_delete from '@/components/icon_delete.vue';

Vue.use(
    Vuetify, {
        iconfont: 'fa'
  },
)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#35b729',
                info: '#35b729',
                success: '#35b729',
                error: '#ff6285',
                ppc_darkgreen:'#35b729',
                ppc_lightgreen: '#99e265',
                ppc_grey: '#c7d3d1',
                ppc_pink: '#ff6285',
                background: '#ff6285'
            }
        }
    },
    icons: {
        values: {
          icon_volunteer: { // name of our custom icon
            component: icon_volunteer, // our custom component
          },
          icon_internship: { // name of our custom icon
            component: icon_internship, // our custom component
          },
          icon_spanish: { // name of our custom icon
            component: icon_spanish, // our custom component
          },
          icon_accommodation: { // name of our custom icon
            component: icon_accommodation, // our custom component
          },
          icon_tours: { // name of our custom icon
            component: icon_tours, // our custom component
          },
          icon_packages: { // name of our custom icon
            component: icon_packages, // our custom component
          },
          icon_sale: { // name of our custom icon
            component: icon_sale, // our custom component
          },
          icon_delete: { // name of our custom icon
            component: icon_delete, // our custom component
          },
        },
    },
})
